import React from "react";
import CustomerDialog from "../CustomerDialog";

interface Props {
  customerAdd: boolean;
  setCustomerAdd: (v: boolean) => void;
  firstName: string;
  setFirstName: (v: string) => void;
  middleName: string;
  setMiddleName: (v: string) => void;
  lastName: string;
  setLastName: (v: string) => void;
  phoneNumber: string;
  setPhoneNumber: (v: string) => void;
  tableNumber: string;
  setTableNumber: (v: string) => void;
  handleSubmit: () => void;
  searchTerm: string;
  setSearchTerm: (value: string) => void;
}

const CustomerDialogWrapper: React.FC<Props> = ({ 
  customerAdd, 
  setCustomerAdd, 
  firstName, 
  setFirstName,
  middleName,
  setMiddleName,
  lastName,
  setLastName,
  phoneNumber, 
  setPhoneNumber, 
  tableNumber, 
  setTableNumber, 
  handleSubmit, 
  searchTerm, 
  setSearchTerm 
}) => {
  const handleCloseCustomer = () => {
    setCustomerAdd(false);
    // Reset form fields when closing
    setFirstName("");
    setMiddleName("");
    setLastName("");
    setPhoneNumber("");
    setTableNumber("");
  };

  return (
    <CustomerDialog
      customerAdd={customerAdd}
      handleCloseCustomer={handleCloseCustomer}
      firstName={firstName}
      setFirstName={setFirstName}
      middleName={middleName}
      setMiddleName={setMiddleName}
      lastName={lastName}
      setLastName={setLastName}
      phoneNumber={phoneNumber}
      setPhoneNumber={setPhoneNumber}
      handleSubmit={handleSubmit} 
      searchTerm={searchTerm}
      setSearchTerm={setSearchTerm}
    />
  );
};

export default CustomerDialogWrapper;